import { getYear, getMonth } from 'date-fns'

import { SelectionMenuOption } from '~/components/Selections/SelectionMenu'
import StandardUniselection from '~/components/Selections/StandardUniselection'

import { DatePickerHeader } from '../styles'

import { CustomHeaderProps } from '../type'

const range = (start: number, end: number) =>
  Array(Math.abs(end - start) + 1)
    .fill(Math.max(start, end))
    .map((value, index) => value - index)

const getOption = (value: number | string, options: SelectionMenuOption[]) => {
  const parsedValue = value.toString()

  return options.find(({ value }) => value === parsedValue)
}

const CustomHeader = ({
  date,
  changeYear,
  changeMonth,
  language,
  minimumYear,
  maximumYear
}: CustomHeaderProps) => {
  const years = range(minimumYear, maximumYear).map((year) => {
    const yearString = year.toString()

    return {
      id: yearString,
      label: yearString,
      value: yearString
    }
  })

  const months = Array.from({ length: 12 }, (_, index) => {
    const month = new Date(0, index + 1, 0).toLocaleDateString(language, {
      month: 'long'
    })

    const upperCaseMonth = month.charAt(0).toUpperCase() + month.slice(1)

    return {
      id: upperCaseMonth,
      label: upperCaseMonth,
      value: index.toString()
    }
  })

  return (
    <DatePickerHeader>
      <StandardUniselection
        options={months}
        selectedOption={months[getMonth(date ?? 0)]}
        onSelect={(selected) => {
          changeMonth(parseInt((selected as SelectionMenuOption).value))
        }}
        heightClass='regular'
      />
      <StandardUniselection
        options={years}
        selectedOption={getOption(getYear(date ?? 0), years)}
        onSelect={(selected) => {
          changeYear(parseInt((selected as SelectionMenuOption).value))
        }}
        heightClass='regular'
      />
    </DatePickerHeader>
  )
}

export default CustomHeader
